import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import DashboardInventoryContainer from '../../dashboard-inventory/containers/DashboardInventoryContainer';
import Panel from '../../elements/Panel/Panel';
import SidebarLayout from '../../elements/SidebarLayout/SidebarLayout';
import VerticalSplitPane from '../../elements/VerticalSplitPane/VerticalSplitPane';
import ApplicationControlsContainer from './ApplicationControlsContainer';
import ApplicationDrawerContainer from './ApplicationDrawerContainer';
import ApplicationsSidebarContainer from './ApplicationsSidebarContainer';
import ApplicationTableContainer from './ApplicationTableContainer';

const ApplicationsContainer: FC = () => {
  return (
    <SidebarLayout aside={<ApplicationsSidebarContainer />}>
      <Stack direction='column' height='100%'>
        <Panel flexShrink={0}>
          <DashboardInventoryContainer hideAppsCount />
        </Panel>
        <ApplicationControlsContainer />
        <Stack flex='1 1 auto' sx={{ overflowY: 'auto' }}>
          <Box width='100%' height='100%'>
            <VerticalSplitPane content={<ApplicationTableContainer />}>
              {({ className }) => (
                <ApplicationDrawerContainer className={className} />
              )}
            </VerticalSplitPane>
          </Box>
        </Stack>
      </Stack>
    </SidebarLayout>
  );
};

export default ApplicationsContainer;
